module.exports = __webpack_public_path__ + "static/media/shop-icon.9b511d74.svg";